import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  POSTProgramCatalogCategory,
  PostProgramCatalogCategoryPayload,
} from '../requests'

type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type
type Options = Omit<
  UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
  'mutationFn'
>

export const usePostProgramCatalogCategory = (
  programId: number,
  options: Options
) => {
  return useMutation({
    mutationFn: async (payload: PostProgramCatalogCategoryPayload) => {
      return POSTProgramCatalogCategory(programId, payload)
    },
    mutationKey: [],
    ...options,
  })
}
